import styled from 'styled-components';

const handleSize = size => {
  switch (size) {
    case 'small':
      return {
        maxWidth: '500px',
        width: '50%',
        height: 'auto',
      };

    case 'medium':
      return {
        maxWidth: '900px',
        width: '100%',
        height: 'auto',
      };

    case 'large':
      return {
        maxWidth: 'none',
        width: '100%',
        height: 'auto',
      };

    case 'fullscreen':
      return {
        maxWidth: 'none',
        width: '100%',
        height: '100vh',
      };

    default:
      return {
        maxWidth: '900px',
        width: '100%',
        height: 'auto',
      };
  }
};

export const Wrap = styled.picture`
  width: ${props => handleSize(props.size).width};
  height: ${props => handleSize(props.size).height};
  max-width: ${props => handleSize(props.size).maxWidth};
  display: block;
  margin: 1rem auto;
`;
